var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChecked = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.996 28c-4.449 0-7.908-1.16-10.282-3.45C1.25 22.175 0 18.63 0 14.005 0 9.383 1.249 5.832 3.714 3.455 6.088 1.165 9.551 0 13.996 0c4.449 0 7.908 1.16 10.286 3.45C26.752 5.829 28 9.38 28 14.003c0 4.623-1.253 8.17-3.718 10.547C21.904 26.84 18.445 28 13.996 28zm0-26.448c-8.259 0-12.448 4.188-12.448 12.454 0 8.258 4.19 12.446 12.448 12.446 8.263 0 12.456-4.188 12.456-12.446 0-8.262-4.193-12.454-12.456-12.454zm-2.61 18.354c.14.176.352.275.575.275h.016a.728.728 0 0 0 .575-.295l8.21-10.994a.732.732 0 1 0-1.172-.878L11.94 18.251l-3.168-3.982a.734.734 0 0 0-1.029-.115.734.734 0 0 0-.116 1.029l3.759 4.723z",
    fill: "#019DF4"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChecked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checked.54c5dd32.svg";
export { ForwardRef as ReactComponent };